import { createAsyncThunk } from '@reduxjs/toolkit'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../helpers/EventEmitter'
import CategoryService from './CategoryService'

export const postCategoryCheckData = createAsyncThunk(
  'checkDataAvailability/postCategoryCheckData',
  async (data, { rejectWithValue }) => {
    try {
      const res = await CategoryService.postCategoryCheckData(data)

      if (res.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'domesticSearchPreview.CHECK_DATA_AVAILABILITY_CONFIRM',
        )
      }

      return rejectWithValue('Error')
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
